import { AssistantItems } from '@repo/shared/dtos/assistant'
import { BeneficiaryInsightDimensionsDTO } from '@repo/shared/dtos/beneficiary'
import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { useState } from 'react'

import { addInsightWidget } from '@/store/beneficiary-insights/thunks'
import { useStoreDispatch } from '@/store/hooks'

export function AddInsightWidgetButton({
  item,
}: {
  item: AssistantItems['beneficiaryInsightsCta']
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.chat' })
  const dispatch = useStoreDispatch()

  const [isDisabled, setIsDisabled] = useState(false)

  const handleAddWidget = () => {
    const recommendedDisplay = item.recommendedDisplay
    if (!recommendedDisplay) return

    setIsDisabled(true)

    const attributes = {
      title: recommendedDisplay.title ?? 'Unknown title',
      description: recommendedDisplay.description ?? 'Unknown description',
      type: recommendedDisplay.type ?? 'kpi',
      width: 1,
      height: 1,
      filters: item.filters ?? [],
      dimensions: item.dimensions ?? ([] as unknown as BeneficiaryInsightDimensionsDTO),
      metrics: item.metrics ?? [],
    }

    void dispatch(addInsightWidget(attributes))
  }

  return (
    <Button variant="outline" size="sm" onClick={handleAddWidget} disabled={isDisabled}>
      {t('addWidget', { cfl: true })}
    </Button>
  )
}
